import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'jotai';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Layout from './pages/_layout';
import DashboardPage from './pages/dashboard';
import ReportPage from './pages/report';
import CombinedPage from './pages/combined';
import AdminTemplatesPage from './pages/admin-templates';
import AdminUsersPage from './pages/admin-users';
import { NotFoundPage } from '@higgins/ui';
import { RequireAdmin } from './components/require-admin';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
    <Provider>
      <Router>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<DashboardPage />} />
            <Route path="reports/:id" element={<ReportPage />} />
            <Route path="combined" element={<CombinedPage />} />
            <Route path="admin/templates" element={<RequireAdmin><AdminTemplatesPage /></RequireAdmin>} />
            <Route path="admin/users" element={<RequireAdmin><AdminUsersPage /></RequireAdmin>} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </Router>
    </Provider>
    </QueryClientProvider>
  );
}
